/**
 * TanStack Query hooks for `cc-subscribe`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	cancelSubscription,
	ccSubscribeQueryKeys,
	confirmIntent,
	createIntent,
	getMe,
	type CcSubscribeSubscription,
	type ConfirmIntentBody,
	type CreateIntentBody,
	type CreateIntentResponse,
	type GetMeResponse,
} from "./api";

export function useCcSubscribeList(): UseQueryResult<GetMeResponse, Error> {
	return useQuery({
		queryKey: ccSubscribeQueryKeys.list(),
		queryFn: getMe,
	});
}

export function useCcSubscribeCreate(): UseMutationResult<
	CreateIntentResponse,
	Error,
	CreateIntentBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: createIntent,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ccSubscribeQueryKeys.all });
		},
	});
}

export function useCcSubscribeConfirm(): UseMutationResult<
	CcSubscribeSubscription,
	Error,
	ConfirmIntentBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: confirmIntent,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ccSubscribeQueryKeys.all });
		},
	});
}

export function useCcSubscribeDelete(): UseMutationResult<
	CcSubscribeSubscription,
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: cancelSubscription,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ccSubscribeQueryKeys.all });
		},
	});
}
